import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const fetchCities = createAsyncThunk("cities/fetch", async () => {
  const response = await api.get("/cities");
  return response.data.data;
});

export const addCity = createAsyncThunk("cities/add", async (cityData) => {
  const response = await api.post("/cities", cityData);
  return response.data.data;
});

export const updateCity = createAsyncThunk(
  "cities/update",
  async ({ id, data }) => {
    const response = await api.post(`/cities/${id}?_method=PUT`, data); // Laravel-style
    return response.data.data;
  }
);

export const deleteCity = createAsyncThunk("cities/delete", async (id) => {
  await api.delete(`/cities/${id}`);
  return id;
});

const citiesSlice = createSlice({
  name: "cities",
  initialState: {
    cities: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.loading = false;
        state.cities = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addCity.fulfilled, (state, action) => {
        state.cities.push(action.payload);
      })
      .addCase(updateCity.fulfilled, (state, action) => {
        const index = state.cities.findIndex((c) => c.id === action.payload.id);
        if (index !== -1) state.cities[index] = action.payload;
      })
      .addCase(deleteCity.fulfilled, (state, action) => {
        state.cities = state.cities.filter((c) => c.id !== action.payload);
      });
  },
});

export default citiesSlice.reducer;
